import { selectUserPermissions } from '@state-mgmt/slices/appSlice';
import { RootState } from '@state-mgmt/store';
import jwt_decode from 'jwt-decode';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useUserPerms = (): { permissions: string[] | undefined; getUserPermissionsByTrialId: (id: string | null | undefined) => string[] } => {
  const token = localStorage.getItem('accessToken');

  const { clientId, trialId } = useSelector((state: RootState) => state.app);
  const userPermissions = useSelector(selectUserPermissions);

  const clientPermissions = useMemo(() => {
    if (!clientId || !userPermissions?.client) return [];
    return userPermissions.client[clientId] || [];
  }, [clientId, userPermissions]);

  const tokenPermissions = useMemo(() => {
    if (token) {
      // @ts-ignore
      const { perms } = jwt_decode(token);
      return perms as string[];
    }

    return [];
  }, [token]);

  const getUserPermissionsByTrialId = useCallback(
    (id: string | null | undefined) => {
      const trialPermissions = !id || !userPermissions?.trial ? [] : userPermissions.trial[id] || [];
      const allPermissions: string[] = [];

      [...tokenPermissions, ...trialPermissions, ...clientPermissions].forEach(perm => {
        if (!allPermissions.includes(perm)) allPermissions.push(perm);
      });

      return allPermissions;
    },
    [clientId, userPermissions, tokenPermissions, clientPermissions]
  );

  const permissions = useMemo(() => {
    return getUserPermissionsByTrialId(trialId);
  }, [trialId, getUserPermissionsByTrialId]);

  return { permissions, getUserPermissionsByTrialId };
};
